/**
 * Zeequa pre-order: fills every [data-zq-eta] element with an estimated
 * delivery window ("Nov 22 – Nov 29"), counted from today using the
 * element's data-min-days / data-max-days.
 */
(() => {
  const format = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  const fill = () => {
    document.querySelectorAll('[data-zq-eta]').forEach((el) => {
      const min = Number(el.dataset.minDays) || 28;
      const max = Number(el.dataset.maxDays) || 35;
      const from = new Date();
      const to = new Date();
      from.setDate(from.getDate() + min);
      to.setDate(to.getDate() + max);
      el.textContent = `${format(from)} – ${format(to)}`;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fill);
  } else {
    fill();
  }
  document.addEventListener('shopify:section:load', fill);
})();
